var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"record-type"},[_c(_vm.icon,{tag:"component",attrs:{"size":_vm.size}}),_vm._t("default",[_c('span',{staticClass:"avenir-font-offset-1"},[_vm._v(_vm._s(_vm.typeName))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }